import React from 'react';
import PropTypes from 'prop-types';

const ExportsMarketingOption = props => (
  <section className='row option' key={props.optionNumber}>
    <div className='col-xs-2 col-sm-2 col-md-1 iconContainer'>
      <img className='optionIcon' src={props.icon} alt={props.title} />
    </div>
    <div className='col-xs-2 col-sm-1 col-md-1 numberContainer'>
      <h2 className='optionNumber'>{props.optionNumber}</h2>
    </div>
    <div className='col-xs-8 col-sm-9 col-md-10 textContainer'>
      <h3 className='optionTitle'>{props.title}</h3>
      <p className='optionText'>{props.text}</p>
    </div>
  </section>
);

ExportsMarketingOption.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  optionNumber: PropTypes.number,
};

export default ExportsMarketingOption;



// WEBPACK FOOTER //
// ./modules/DataExports/components/home/children/children/marketingOption.js